import { Link } from 'react-router-dom';

const SearchResultsSection = ({ title, items, type, handleResultClick, searchValue }) => (
  <div className="p-2">
    <h3 className="text-sm font-medium text-gray-400 mb-2">{title}</h3>
    {items.slice(0, 4).map((item) => (
      <div
        key={item.id}
        className="p-2 hover:bg-hover-charcoal rounded-lg cursor-pointer"
        onClick={() => handleResultClick(type, item.id || item.name)}
      >
        {item.name || item.title}
      </div>
    ))}
    {items.length > 4 && (
      <Link
        to={`/search?value=${encodeURIComponent(searchValue)}&type=${type}`}
        className="text-sm text-indigo-500 hover:text-indigo-400"
      >
        View All {title}
      </Link>
    )}
  </div>
);

export default SearchResultsSection;